import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  pure: false
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], term: string): any[] {
    if (!items || !term) {
      return items;
    }

    const searchTerm = term.toLowerCase();
    const matches = (value: unknown): boolean => {
      if (value === null || value === undefined) {
        return false;
      }

      if (typeof value === 'object') {
        return Object.values(value).some(matches);
      }

      return String(value).toLowerCase().includes(searchTerm);
    };

    return items.filter(matches);
  }
}
